/**
 * @description 将富文本链接转为跳转事件
 * @author wangfupeng
 */

import { getDomParent } from '../../util'
import { customInvoke } from './index'

/**
 * 富文本链接转为跳转事件
 */
function hrefToEvent () {
    document.body.addEventListener('click', (e) => {
        let elem = e.target
        if (elem.nodeName !== 'A') {
            // 点击的不是 <a> ，再判断上级元素
            const parent = getDomParent(elem, 'a')
            if (parent != null) {
                // 上级元素是 <a>
                elem = parent
            } else {
                // 上级元素没有 <a>
                return
            }
        }

        // 判断链接
        const link = elem.getAttribute('href')
        if (!link) {
            // 找不到链接，则忽略
            return
        }

        // 阻止默认行为和冒泡
        e.preventDefault()
        e.stopPropagation()

        // 模拟一个跳转事件，统一调用
        customInvoke({
            refId: 'dpub3-rich-text-href',
            targetUrl: link, // 直接用链接，而不是 target id
            omegaTrack: elem.textContent // 统计标识
        })
    })
}

export default hrefToEvent
